import React, { useRef, useState } from 'react';
import { useTheme as useMuiTheme, useMediaQuery } from '@material-ui/core';
import styled from 'styled-components';
import { useCroppedImage } from '../../../../hooks';
import fallbackWithImageDimensions from '../../../../utils/fallbackWithImageDimensions';
import UnsplashCredit from '../../../Unsplash/UnsplashCredit';
import ViewerErrorBoundary from '../common/ViewerConclusion/ViewerErrorBoundary';
import ImageModal from './ImageModal';
const ImageWrapper = styled.div `
    &:hover {
        cursor: pointer;
    }

    img {
        max-width: 100%;
        height: auto;
    }
`;
const CaptionWrapper = styled.div `
    display: flex;
    align-items: center;
    text-align: center;
    flex-direction: column;
    font-size: ${(props) => props.theme.fonts.textSizeStandard};
    color: ${(props) => props.theme.colors.textSecondary};

    p {
        margin: 0;
    }
`;
const ImageViewContainer = styled.div `
    display: grid;
    align-items: center;
    justify-content: center;
    max-width: 100%;
`;
const DEFAULT_IMAGE_ALT = 'Skill Image';
const DEFAULT_UNSPLASH_IMAGE_ALT = 'Skill Unsplash Image';
const ImageViewer = ({ componentValues }) => {
    var _a;
    const [hidden, setHidden] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const imageRef = useRef(null);
    const muiTheme = useMuiTheme();
    const isMobile = useMediaQuery(muiTheme.breakpoints.down('xs'));
    const { image, caption, imageUrl: externalUrl, imageComponentOverride: ImageOverride } = componentValues !== null && componentValues !== void 0 ? componentValues : {};
    const { url: imageUrl, dimensions, crop } = image !== null && image !== void 0 ? image : {};
    const { imageSrc } = useCroppedImage(imageUrl, crop, { placeholderImageSrc: imageUrl });
    const onError = () => {
        setHidden(true);
    };
    const renderCaption = () => {
        if (caption) {
            return React.createElement("p", null, caption);
        }
        return null;
    };
    const renderUploadedImage = () => {
        const { width, height } = fallbackWithImageDimensions(dimensions);
        return (React.createElement(ViewerErrorBoundary, null,
            React.createElement(ImageWrapper, { onClick: () => setModalOpen(true) }, ImageOverride ? (React.createElement(ImageOverride, { imgRef: imageRef, src: imageSrc !== null && imageSrc !== void 0 ? imageSrc : undefined, onError: onError, width: width, height: height, alt: caption !== null && caption !== void 0 ? caption : DEFAULT_IMAGE_ALT })) : (React.createElement("img", { ref: imageRef, src: imageSrc !== null && imageSrc !== void 0 ? imageSrc : undefined, onError: onError, width: isMobile ? 'auto' : width, height: isMobile ? 'auto' : height, alt: caption !== null && caption !== void 0 ? caption : DEFAULT_IMAGE_ALT }))),
            React.createElement(CaptionWrapper, null, renderCaption())));
    };
    const renderExternalImage = () => {
        return (React.createElement(ViewerErrorBoundary, null,
            React.createElement(ImageWrapper, { onClick: () => setModalOpen(true) }, ImageOverride ? (React.createElement(ImageOverride, { imgRef: imageRef, src: externalUrl !== null && externalUrl !== void 0 ? externalUrl : undefined, onError: onError, alt: caption !== null && caption !== void 0 ? caption : DEFAULT_UNSPLASH_IMAGE_ALT })) : (React.createElement("img", { ref: imageRef, src: externalUrl !== null && externalUrl !== void 0 ? externalUrl : undefined, onError: onError, alt: caption !== null && caption !== void 0 ? caption : DEFAULT_UNSPLASH_IMAGE_ALT }))),
            React.createElement(CaptionWrapper, null,
                renderCaption(),
                React.createElement(UnsplashCredit, { profile: componentValues === null || componentValues === void 0 ? void 0 : componentValues.profile, photographer: componentValues === null || componentValues === void 0 ? void 0 : componentValues.photographer }))));
    };
    if ((!imageSrc && !externalUrl) || hidden) {
        return null;
    }
    return (React.createElement(ViewerErrorBoundary, null,
        React.createElement(ImageViewContainer, null,
            externalUrl ? renderExternalImage() : renderUploadedImage(),
            React.createElement(ImageModal, { src: externalUrl ? externalUrl : imageSrc, open: modalOpen, onClose: () => setModalOpen(false), alt: caption !== null && caption !== void 0 ? caption : DEFAULT_IMAGE_ALT, initialWidth: (_a = imageRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth }))));
};
export default ImageViewer;
//# sourceMappingURL=index.js.map